import { isMobile, isDesktop } from '../../common/_constants'
import { waitForElmBySelectorIndex } from '../helpers/_observer-handler'

export const nbaSubMenuHandler = () => {
    const nbaSubMenu = document.querySelector('.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu')
    const nbaMoreSubMenuButton = document.querySelector('.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second')
    const availableSpace = 500
    let nbaSubMenuWidth = 0

    if (nbaSubMenu && isDesktop()) {
        if (!nbaMoreSubMenuButton) {
            const moreSecondItem = document.createElement("li")

            moreSecondItem.classList.add("menu-item", "more-second")
            moreSecondItem.innerHTML = "<a>...</a><ul class='more-submenu-second'></ul>"
            nbaSubMenu.appendChild(moreSecondItem)
        }

        nbaSubMenuWidth = nbaSubMenu.offsetWidth
        if (nbaSubMenuWidth > availableSpace) {
            const nbaSubMenuItems = document.querySelectorAll(".primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > li:not(.more-second)")
            const nbaSubMenuLastItem = nbaSubMenuItems[nbaSubMenuItems.length - 1]
            const nbaMoreSubMenu = document.querySelector(".primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second > ul.more-submenu-second")

            nbaSubMenuLastItem.dataset.width = nbaSubMenuLastItem.offsetWidth
            nbaMoreSubMenu.prepend(nbaSubMenuLastItem)
            document.querySelector(".primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second").classList.add("has-items")

            nbaSubMenuHandler()

            const nbaSubMenuAllItems = document.querySelectorAll('.primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .menu-item')
            nbaSubMenuAllItems.forEach(item => {
                item.classList.add('visible')
            })
        }

        const moreItems = document.querySelectorAll(".primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second > .more-submenu > .menu-item").length
        const nbaMoreSubMenu = document.querySelector(".primary-menu-wrapper > .menu > .menu-item--active-trail > .nba-menu-wrapper > .nba-menu-inner > .menu > .more-second > .more-submenu")

        if (moreItems > 9 && moreItems <= 18) {
            nbaMoreSubMenu.classList.add("two-columns")
        }
        if (moreItems > 18 && moreItems <= 27) {
            nbaMoreSubMenu.classList.add("three-columns")
        }
        if (moreItems > 27 && moreItems <= 36) {
            nbaMoreSubMenu.classList.add("four-columns")
        }
    }
}


export const nbaLogoHandler = () => {
    const bottomPrimaryMenu = document.querySelector('.tsn-primary-menu__bottom')
    const isNbaSibPage = document.querySelectorAll('.primary-menu-wrapper .nba-menu-wrapper .branded-secondary-nav-buttons').length > 0
    const nbaSibHeader = document.querySelectorAll(".tsn-primary-menu__bottom .nba-sib-header")

    if (isNbaSibPage && isMobile()) {
        // Handles mobile sub menu of NBA
        bottomPrimaryMenu.classList.add("is-nba")

        const hasMoreItems = document.querySelector(".primary-menu-wrapper .menu-item--active-trail .nba-menu-wrapper .nba-menu-inner > .menu > .more-second.has-items")

        if (hasMoreItems && hasMoreItems.classList.contains("is-active")) {
            hasMoreItems.classList.remove("is-active")
        }

        waitForElmBySelectorIndex('.primary-menu-wrapper .menu-item--active-trail .nba-menu-wrapper .nba-menu-inner > .menu', 0).then((menuItems) => {
            if (hasMoreItems) {

                bottomPrimaryMenu.appendChild(menuItems.cloneNode(true))

                const submenuElement = hasMoreItems.querySelector('.more-submenu-second')
                const submenuItems = submenuElement.querySelectorAll('.menu-item')
                const parentElement = document.querySelector('.tsn-primary-menu__bottom .menu')
                const nbaSibMobileMenu = parentElement.querySelector('.more-second.has-items')
                const fragment = document.createDocumentFragment()

                submenuItems.forEach((item) => {
                    fragment.appendChild(item.cloneNode(true))
                })

                parentElement.appendChild(fragment)

                nbaSibMobileMenu.remove()
            } else {
                bottomPrimaryMenu.appendChild(menuItems.cloneNode(true))
            }
        })

        // Handles mobile NBA title and logos
        let pageTitleWrap = document.createElement("div")
        pageTitleWrap.classList.add("nba-sib-header")

        let pageTitle = document.createElement("h1")
        pageTitle.classList.add("page-title")
        pageTitle.textContent = "NBA"
        pageTitleWrap.appendChild(pageTitle)

        const nbaSibHeader = document.querySelector('.nba-sib-header')
        const secondaryNavButtons = document.querySelector(".primary-menu-wrapper .menu-item--active-trail .nba-menu-wrapper .branded-secondary-nav-buttons")
        let alreadyAppended = false

        if (!alreadyAppended && !nbaSibHeader) {
            bottomPrimaryMenu.appendChild(pageTitleWrap)
            document.querySelector(".tsn-primary-menu__bottom .nba-sib-header").appendChild(secondaryNavButtons.cloneNode(true))
            alreadyAppended = true
        } else if (alreadyAppended && nbaSibHeader) {
            pageTitleWrap.remove()
            alreadyAppended = false
        }
    }
    else if (isNbaSibPage && isDesktop() && nbaSibHeader) {
        nbaSibHeader.forEach(element => {
            element.remove()
        })
        // nbaSibMobileMenu.remove()
    }
}
